import { render } from "./edit-profile.vue?vue&type=template&id=716e5f65&ts=true"
import script from "./edit-profile.vue?vue&type=script&lang=ts"
export * from "./edit-profile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__